import React, { useState, useEffect } from 'react'
import { MiFooter } from '../../components/footer/MiFooter';
import { ContentBodyDocumentos } from '../../components/Documentos/ContentBodyDocumentos';
import HeaderHome from '../../components/headerHome/HeaderHome';

export const Documentos = () => {

  const [MenuLateralAux, setMenuLateralAux] = useState();

  const chageMenuLateralAux = () => {
    setMenuLateralAux(!MenuLateralAux)
  }

  return (
    <div className='UserFeedback'>
      <div className='headerUserFeedback'>
        <HeaderHome
          chageMenuLateralAux={chageMenuLateralAux}
        />
      </div>
      <div className="bodyUserFeedback">
        <ContentBodyDocumentos
          MenuLateralAux={MenuLateralAux}
          chageMenuLateralAux={chageMenuLateralAux}
        />
      </div>
      <div className='footerReservarServicio'>
        <MiFooter
        />
      </div>
    </div>
  )
}
